import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import { ManagerAvailabilityResponseSchema } from "@applicant-reviewer/api";

// GET /manager-availability — returns the current manager's availability, or null if not set
export function useManagerAvailability(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.managerAvailability.detail(),
    queryFn: () => apiClient.get("/manager-availability", ManagerAvailabilityResponseSchema),
    enabled: options?.enabled ?? true,
  });
}
